import { Box, Button, Flex, HStack, Image, Select, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaArrowLeft, FaArrowRight, FaBackspace, FaEdit, FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa'
import { FaGears } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../components/InputCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { appApi } from '../../../services/appApi'
import { CardColaboradorSi } from '../../AssessmentPI/components/TabelaAderencia/components/cardColabSI'
import { Body } from '../../Layouts/Body'

interface IEmpresaDDL{
  nome: string
  empresaId: string
  logo: string

}

interface IListaPerfilDTO{
  totalRegistrosEncontrados: number
  totalPaginas: number
  resultadoBusca: IperfilDto2[]
}

export interface IperfilDto2 {
  assessmentId: string
  assessmentUserId: string
  email: string
  nome: string
  dataConclusao: string
  pi: number
  self: iSelf
  selo: iSelo
}

export interface iSelf {
  aSigma: number
  bSigma: number
  cSigma: number
  dSigma: number
  eSigma: number
  mScore: number
}

export interface iSelo {
  definicao: string
  nome: string
  urlAvatar: string
}

export const NovaArquiteturaHumana: React.FC = () => {
  const numberFormatter = Intl.NumberFormat('pt-BR')
  const [empresa, setEmpresa] = useState<IEmpresaDDL>()
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingLista, setIsLoadingLista] = useState(false)
  const [ocultarLista, setOcultarLista] = useState(true)
  const [buscaPI, setBuscaPI] = useState('')
  const [empresasDDL, setempresasDDL] = useState<IEmpresaDDL[]>([])
  const [pag, setPag] = useState(0)
  const toast = useToast()
  const nav = useNavigate()
  const [perfis, setPerfis] = useState<IListaPerfilDTO>({
    resultadoBusca: [],
    totalPaginas: 0,
    totalRegistrosEncontrados: 0
  })

  const [pessoas, setPessoas] = useState<IperfilDto2[]>([])

  function togglePessoa(novaPessoa: IperfilDto2): void {
    setPessoas((prevPessoas) => {
      const existe = prevPessoas.some((p) => p.assessmentUserId === novaPessoa.assessmentUserId)

      if (existe) {
        toast({
          title: 'Removido Participante',
          description: `${novaPessoa.nome}`,
          status: 'error',
          duration: 2000,
          position: 'top'
        })
        // Se já existe, remove
        return prevPessoas.filter((p) => p.assessmentUserId !== novaPessoa.assessmentUserId)
      } else {
        // Se não existe, adiciona
        toast({
          title: 'Adicionado Participante',
          description: `${novaPessoa.nome}`,
          status: 'success',
          duration: 2000,
          position: 'top'
        })
        return [...prevPessoas, novaPessoa]
      }
    })
  }
  function enviar(): void {
    setIsLoading(true)
    // montar payload com empresaID, UsuarioID,Lista
    const payload = {
      empresaId: empresa?.empresaId,
      participantes: pessoas.map(p => ({
        assessmentUserId: p.assessmentUserId,
        selo: p.selo,
        assessmentId: p.assessmentId,
        dataConclusao: p.dataConclusao,
        nome: p.nome,
        email: p.email,
        pi: p.pi,
        self: p.self
      }))
    }

    appApi.post('api/AH/Cadastrar', payload)
      .then(res => {
        setIsLoading(false)
        toast({
          title: 'Arquitetura Humana cadastrada com sucesso',
          status: 'success',
          duration: 2000,
          position: 'top'
        })
        nav('/ArquiteturaHumana')
      }).catch(res => console.log(res))

    console.log(payload)

    setIsLoading(false)
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const empresaSelecionada = empresasDDL.find(emp => emp.empresaId === e.target.value)
    setEmpresa(empresaSelecionada)
  }

  useEffect(() => {
  // popular DDL EMPRESAS
    setIsLoading(true)
    appApi.get('api/AH/ListarEmpresasDDLPI')
      .then(res => {
        setempresasDDL(res.data)
        setIsLoading(false)
      })
      .catch(err => console.log(err)).finally(() => setIsLoading(false))
  }, [])
  useEffect(() => {
    buscarPI()
  }, [pag])

  function OnPrevPage(): void {
    if (pag !== 0) {
      setPag(pag - 1)
    } else {
      setPag(Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1)
    }
  }

  function OnNextPage(): void {
    if (pag < Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1) {
      setPag(pag + 1)
    } else {
      setPag(0)
    }
  }
  function buscarPI(): void {
    setIsLoadingLista(true)
    setPerfis({
      resultadoBusca: [],
      totalPaginas: 0,
      totalRegistrosEncontrados: 0
    })

    appApi.get(`api/AH/BuscaPI?nome=${buscaPI}&eid=${empresa?.empresaId}&tamanho=${28}&pagina=${pag}&exibirDefinicaoSelo=true`).then(res => {
      if (res.status === 200) {
        const data: IListaPerfilDTO = res.data
        setPerfis(data)
        setIsLoadingLista(false)
      }
    }).catch(err => console.log(err))
    setIsLoadingLista(false)
  }

  function handleEnterPress(event: React.KeyboardEvent<HTMLInputElement>): void {
    if (event.key === 'Enter') {
      buscarPI()
    }
  }

  function handleSelectPerfil(j: IperfilDto2): void {
    togglePessoa(j)
  }
  function verificaSelecao(userId: string): boolean {
    return pessoas.some((pessoa) => pessoa.assessmentUserId === userId)
  }
  return (
  <Body isLoading={isLoading} >
<Flex minH={'350px'} direction={'column'} padding={'1rem'} borderRadius={'2xl'} boxShadow={'base'} backgroundColor={'white'}>

  <Flex my={'1rem'} justifyContent={'space-between'}>
  <h1>Nova Arquitetura Humana</h1>

  <Button size={'sm'} backgroundColor={'var(--c7)'} leftIcon={<FaBackspace/>}
  onClick={() => nav('/ArquiteturaHumana')}>Voltar</Button>
  </Flex>
  <Box>
  <Flex flexDirection={'column'} gap={'1rem'}>
  {empresa !== undefined && (

    <Flex flexDirection={'column'} gap={'1rem'}>

      <Image
      src={empresa?.logo}
       alt="Logo da empresa selecionada"
       boxSize={'200px'}
       />

      <Flex>
      <Text>Empresa selecionada: {empresa?.nome}</Text>
      <Button mx='2rem' size={'xs'} backgroundColor={'var(--Rosa)'} leftIcon={<FaEdit/>}
        onClick={() => setEmpresa(undefined)}>Trocar Empresa
      </Button>
      </Flex>
      <Box height={'2px'} bgColor='gray.300'></Box>
    </Flex>
  )}
  {(empresa === undefined || empresa?.empresaId === '') && (
  <>
  <Text width={'20rem'}>Selecione a Empresa:</Text>

    <Select value={empresa?.empresaId ?? ''} onChange={handleChange}>
    <option value={''}>Selecione uma Empresa</option>
    {empresasDDL?.map(e => (
      <option value={e.empresaId} key={e.empresaId} >
        {e.nome}
      </option>
    ))}
  </Select>
    </>
  )}
{empresa !== undefined && (
  <Box>
    <Flex>

    <Text fontWeight={'medium'} my='0.5rem' color='var(--Rosa)'>Pessoas selecionadas: {pessoas.length}</Text>
     {pessoas.length > 0 && <Button mx='2rem' size={'xs'} backgroundColor={'var(--Rosa)'} leftIcon={ocultarLista ? <FaEye/> : <FaEyeSlash/>}
        onClick={() => setOcultarLista(!ocultarLista)}> {ocultarLista ? 'Exibir' : 'Ocultar'} lista
      </Button>
      }
     {pessoas.length > 0 && <Button mx='2rem' size={'md'} backgroundColor={'var(--Azul)'} leftIcon={<FaGears/>}
        onClick={() => enviar()}> Processar Arquitetura Humana
      </Button>
      }
    </Flex>
   {!ocultarLista && pessoas.length > 0 && <Flex
   flexDirection={'column'}
   border={'1px'} p={'0.5rem'} overflow={'auto'}
    height='300px'
    borderColor='blue.200'
    gap={'4px'}
    >
    {!ocultarLista && pessoas.map((j, i) =>
                    <CardColaboradorSi
                    compacto
                      perfil={j}
                      selecionado={verificaSelecao(j.assessmentUserId)}
                      onSelect={() => {
                        handleSelectPerfil(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
    )}
                  </Flex>}
    <Box my='1rem' height={'2px'} bgColor='gray.300'></Box>
    <Text>Selecione os participantes:</Text>

     <InputCmp
              label='Nome do participante'
              errorBorderColor='red.300'
              onKeyDown={handleEnterPress}
              OnChange={(s) => setBuscaPI(s)} placeholder='Digite o nome ou email do participante' />

            <Flex justifyContent={'center'} alignItems={'center'} my={'.75rem'} gap={'1rem'}>
                <ElementoTooltipCmp label={'Preencha o nome ou email do participante para pesquisar os perfis PI' } bg={'var(--Red)'}>
                <ButtonCmp leftIcon={<FaEnvelope/>} w='16rem' isDisabled={buscaPI === ''} onClick={() => { buscarPI() }} VarColor='Azul'>
                    Procurar PI do candidato
                </ButtonCmp>
                </ElementoTooltipCmp>
            </Flex>
            <Box my='1rem' height={'2px'} bgColor='gray.300'></Box>

              <LoadingContainer linhas={100} loading={isLoadingLista}>
              {perfis.resultadoBusca.length > 0 && <Flex direction={'column'} gap={'.75rem'} maxH={'22.5rem'} overflowY={'auto'} boxShadow={'var(--SombraBackground)'} border={'1px solid var(--c5)'} p={'1rem .5rem'}>
                {perfis.resultadoBusca.map((j, i) =>
                  <Flex>
                    <CardColaboradorSi
                      perfil={j}
                      selecionado={verificaSelecao(j.assessmentUserId)}
                      onSelect={() => {
                        handleSelectPerfil(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
                  </Flex>
                )}
              </Flex>}
            </LoadingContainer>
            {perfis.totalRegistrosEncontrados > 0 && <Flex justifyContent={'end'}>
              <HStack mt={0} mx={'1.25rem'} p={'.25rem'} fontSize={'.875rem'}>
                <Text>Página:</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnPrevPage()} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                <Text>{numberFormatter.format(pag + 1)} / {Math.ceil(perfis.totalRegistrosEncontrados / 28)}</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnNextPage()} VarColor='Green2'><FaArrowRight/></ButtonCmp>
              </HStack>
            </Flex>}
  </Box>
)}
  </Flex>
  </Box>
  </Flex>
  </Body>)
}
